//Librerie
import { useState, useEffect } from "react";

//COSTANTI
const imgCarousel = [
        "/assets/images/inHome/magic1.jpg",
        "/assets/images/inHome/magic2.jpg",
        "/assets/images/inHome/magic3.jpg"
    ];

const carouselCount = imgCarousel.length;
const quadratiCount = 9; 

const MagicCarousel: React.FC = () => {

    // Carosello
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        const timer = setInterval(handleCarousel, 20000);

        return () => {clearInterval(timer)};
    },[] );
    const handleCarousel = () => {
        setActiveIndex(prec => prec >= carouselCount-1 ? 0 : prec+1)
    }
    //-----------------

    // Quadri animati
    const [squareBg, setSquareBg] = useState(["","","","","","","","",""]);
    const bgType = ['white','gold','blue'];

    useEffect(() => {
        const timer = setInterval(handleSquare, 5000);

        return () => {clearInterval(timer)};
    },[])
    const handleSquare = () => {
        const randomClassIndex = Math.floor(Math.random() * bgType.length);
        const randomClass = bgType[randomClassIndex];
        const randomNumber = Math.floor(Math.random() * 9)
        const newSquareList = [...squareBg];
        if(newSquareList[randomNumber] === ""){
            newSquareList[randomNumber] = randomClass;
            setSquareBg(newSquareList)
        }
    }
    //------------------------

    return(
        <div id="magic-carousel" className="text-center d-inline-block">
            {imgCarousel.map((image, index) => (
                <img key={index} src={image} alt={`Toscana ${index+1}`} className={activeIndex == index ? "active": ""} />
            ))}
            <div className="squares-wrapper">
                {Array.from({length: quadratiCount}).map((_,index) => (
                    <div key={index} className={squareBg[index] != ""? squareBg[index]: ""}></div>
                ))}
            </div>

        </div>
    )
}

export default MagicCarousel